import { create } from 'zustand';

import { ReceiptData } from '../service.types';

const DEFAULT_RECEIPT_DATA: ReceiptData = {
    last_receipt: 1,
    evadts_waiting: 1,
    current_fiscal_datetime_UTC: '',
    current_fiscal_ID: '',
};

interface ServiceState {
    receiptData: ReceiptData;
    setReceiptData: (data: ReceiptData) => void;
    resetReceiptData: () => void;
}

export const useServiceStore = create<ServiceState>((set) => ({
    receiptData: DEFAULT_RECEIPT_DATA,
    setReceiptData: (data) => set({ receiptData: data }),
    resetReceiptData: () => set({ receiptData: DEFAULT_RECEIPT_DATA }),
}));
